import { Flex } from 'foundations-components/components/Flex';
import { DEFAULT_LIMIT } from '../data/useTicketListings';
import { InboxNavTicketRow } from './InboxNavTicketRow';
import { InboxNavTicketRowSkeleton } from './InboxNavTicketRowSkeleton';
import { TicketListEmptyState } from './TicketListEmptyState';
import { jsx as _jsx } from "react/jsx-runtime";
export function InboxNavTicketList({
  tickets,
  loading,
  error,
  hasActiveFilters
}) {
  if (loading) {
    return /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      children: Array.from({
        length: DEFAULT_LIMIT
      }).map((_, i) => /*#__PURE__*/_jsx(InboxNavTicketRowSkeleton, {}, i))
    });
  }
  if (!tickets || tickets.length === 0) {
    return /*#__PURE__*/_jsx(TicketListEmptyState, {
      error: error,
      hasActiveFilters: hasActiveFilters,
      headingTypography: "heading-100",
      clearFiltersScreen: "ticket-details-inbox-nav"
    });
  }
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    children: tickets.map(ticket => /*#__PURE__*/_jsx(InboxNavTicketRow, {
      ticket: ticket
    }, ticket.hs_ticket_id))
  });
}